import { render, staticRenderFns } from "./LevelFilters.vue?vue&type=template&id=5606dc1a&scoped=true"
import script from "./LevelFilters.vue?vue&type=script&lang=ts"
export * from "./LevelFilters.vue?vue&type=script&lang=ts"
import style0 from "./LevelFilters.vue?vue&type=style&index=0&id=5606dc1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5606dc1a",
  null
  
)

export default component.exports